export default __webpack_public_path__ + "images/not_including_baggage.96a3ace.svg";